import { render, staticRenderFns } from "./UserTableComponent.vue?vue&type=template&id=3087916a&scoped=true&"
import script from "./UserTableComponent.vue?vue&type=script&lang=js&"
export * from "./UserTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserTableComponent.vue?vue&type=style&index=0&id=3087916a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3087916a",
  null
  
)

export default component.exports